<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    search
                </mat-icon>
                <span>
                    Search Request: {{ itemEnvelope?.ItemId }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Search Request Name" [(ngModel)]="itemEnvelope.Document.Item.Name" />
                </mat-form-field>
                <br />
                <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <input matInput *ngIf="itemEnvelope" name="Description" placeholder="Description" [(ngModel)]="itemEnvelope.Document.Item.Description" />
                </mat-form-field>
            </form>
            <mat-tab-group>
                <br />
                <mat-tab label="General">
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>Type</mat-label>
                        <mat-select name="SearchRequestTypes" [(ngModel)]="this.itemEnvelope?.Document?.Item.SearchRequestTypeId">
                            <mat-option *ngFor="let searchRequestType of this.searchRequestTypes" [value]="searchRequestType.SearchRequestTypeId">{{ searchRequestType.UID }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <br />
                    <mat-form-field style="width:100%;height: 40%;" appearance="outline">
                        <mat-label>Search Request JSON</mat-label>
                        <textarea matInput name="RequestJson" rows="20" placeholder="" [(ngModel)]="resourceSearchRequestJson" style="font-family: 'Source Code Pro', monospace;"></textarea>
                    </mat-form-field>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
